import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { GlobalStatusEnum } from "@/model/data/status/GlobalStatusEnum";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { TagValues } from "@/model/data/Tag";
import { ConnectivityStatusEnum } from "@/model/data/status/ConnectivityStatusEnum";

export class GetInstallationsEnabledModulesReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    globalStatusFilter: GlobalStatusEnum[] = [];
    connectivityStatusFilter: ConnectivityStatusEnum[] = [];
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    registrationDateRange: string[] = [];
    installationPrefix: string = null;
    tagValues: TagValues = null;
    machineModels: string[] = null;
    // enabledModules: number = 0;
    // disabledModules: number = 0;

    /**
     * Enable or disable single module (column filters)
     * -1: All
     * 0: Disabled
     * 1: Enabled
     */
    ServiceAndUpdatesManagement: -1 | 0 | 1 = -1;
    CashFlowManagement: -1 | 0 | 1 = -1;
    FitnessStatistics: -1 | 0 | 1 = -1;
    SecurityManagement: -1 | 0 | 1 = -1;
}

export function GetServerInstallationsEnabledModulesReqData(req: GetInstallationsEnabledModulesReqData) {
    let enabledModules: number = 0;
    let disabledModules: number = 0;

    Object.keys(LicenseModuleEnum).forEach((k) => {
        if (req[k] != null) {
            if (req[k] == 1) {
                enabledModules = enabledModules + LicenseModuleEnum[k];
            } else if (req[k] == 0) {
                disabledModules = disabledModules + LicenseModuleEnum[k];
            }
        }
    });

    let res = {
        installationNames: req.installationNames,
        folderIds: req.folderIds,
        branchNames: req.branchNames,
        globalStatusFilter: req.globalStatusFilter,
        connectivityStatusFilter: req.connectivityStatusFilter,
        queryLimit: req.queryLimit,
        offset: req.offset,
        orderBy: req.orderBy,
        orderByDescending: req.orderByDescending,
        installationLastMessageDateRange: req.installationLastMessageDateRange,
        agentLastMessageDateRange: req.agentLastMessageDateRange,
        registrationDateRange: req.registrationDateRange,
        enabledModules: enabledModules,
        disabledModules: disabledModules,
    };
    return res;
}
